import { Stack, type StackProps, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = Omit<StackProps, "children"> & {
	bg: string;
	shape?: "rounded" | "circle";
	size?: number;
	children: ReactNode;
};

export const IconBox: FC<Props> = ({
	bg,
	shape = "rounded",
	size,
	children,
	...stackProps
}) => {
	const theme = useTheme();
	const boxSize = size ?? theme.iconBoxSize.md;

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			flexShrink={0}
			width={boxSize}
			height={boxSize}
			bgcolor={bg}
			borderRadius={shape === "circle" ? "50%" : theme.radii.lg}
			{...stackProps}
		>
			{children}
		</Stack>
	);
};
